import PropTypes from 'prop-types';
import { memo } from 'react';

import Leaflet from 'leaflet';
import config from '../../../config';
import useMarker from '../../openMap/useMarker';


const CurrentPositionMarker = ({coords, onMove}) => {
    const marker = new Leaflet.Marker(coords, {
        icon: Leaflet.icon({
            iconUrl: `/images/station-marker-${config.get('brand').split('-')[0]}.svg`,
            iconSize: [50, 50],
            iconAnchor: [25, 50],
        }),
        draggable: true,
    }).on('dragend', (e) => onMove(e.target.getLatLng()));

    useMarker(marker);
    return undefined;
};

CurrentPositionMarker.propTypes = {
    coords: PropTypes.objectOf({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }),
    onMove: PropTypes.func.isRequired
};

export default memo(CurrentPositionMarker);



// WEBPACK FOOTER //
// ./src/components/stationFinder/OpenStreetMaps/CurrentPositionMarker.js